import React from 'react'
import { NamedRoutes } from '../../../../routes'
import PageTitle from '../../PageTitle/PageTitle'
import ExternalEntityGroupForm from './ExternalEntityGroupForm'
import BreadCrumb from '../../BreadCrumb'
import { FormattedMessage } from 'react-intl'
import { ExternalEntityGroupConsumer } from '../../../../ExternalEntityGroupContext'
import { Grid } from '@material-ui/core'
import { useStyles } from './Styles'
import { Alert } from '@material-ui/lab'
import { FormLoader } from '../../../Loader/FormLoader'

export default function ExternalEntityGroupEditContent({ pageTitle, handleNotificationCall }) {
  const classes = useStyles()
  return (
    <>
      <BreadCrumb links={[
        {
          key: 'BreadcrumbLink-1',
          name: <FormattedMessage id='Sidebar.Links.ExternalEntityGroups' />,
          link: NamedRoutes.subscription.externalEntityGroups.list
        }
      ]} current={pageTitle ?? <FormattedMessage id='ExternalEntityGroups.List.AddExternalEntityGroup.Title' />} />
      <PageTitle title={pageTitle ?? <FormattedMessage id='ExternalEntityGroups.List.AddExternalEntityGroup.Title' />} />
      <ExternalEntityGroupConsumer>
        {({ isLoading, externalEntityGroupData, externalEntityGroupDataFailure, isEdit, handleSubmit, externalServiceHandlers }) => (
          <Grid container spacing={4}>
            <Grid item xs={12} className={classes.EditProfileContentContainer}>
              <div className={classes.EditProfileContent}>
                {!!isLoading && <FormLoader loading={true} />}
                {!!externalEntityGroupDataFailure &&
                  <Alert severity="error"><FormattedMessage id='UpdateProfile.FormErrorAlert' /></Alert>
                }
                {!isLoading && (
                  !!isEdit ?
                    (!!externalEntityGroupData && !!Object.keys(externalEntityGroupData).length &&
                      <ExternalEntityGroupForm externalEntityGroupData={externalEntityGroupData} onSubmit={handleSubmit} handleNotificationCall={handleNotificationCall} externalServiceHandlers={externalServiceHandlers} />
                    )
                    :
                    <ExternalEntityGroupForm externalEntityGroupData={{}} onSubmit={handleSubmit} handleNotificationCall={handleNotificationCall} externalServiceHandlers={externalServiceHandlers} />
                )}
              </div>
            </Grid>
          </Grid>
        )}
      </ExternalEntityGroupConsumer>
    </>
  )
}
